/* DTF Africa Merch Maker usage bridge. Candidate: disabled until receiver QA/activation. */
(function () {
  "use strict";
  var win = window;
  var doc = document;
  var origin = "https://logo-print-studio.lovable.app";
  var names = ["preview_success", "mockup_download", "order_click"];
  // Leave false until the dedicated receiver and production activation are approved.
  var destinationEnabled = false;
  var destination = destinationEnabled
    ? function (name, count) {
        if (!names.includes(name) || count !== 1) return;
        var analytics = win.Shopify && win.Shopify.analytics;
        if (!analytics || typeof analytics.publish !== "function") return;
        // Shopify adds its standard envelope. The receiver must never forward that envelope.
        analytics.publish("dtf_merch_maker:" + name, { count: 1 });
      }
    : null;
  if (win.__dtfStudioAnalyticsStop) win.__dtfStudioAnalyticsStop();
  var stopped = false;
  var active = true;
  var seen = new WeakMap();
  var permissions = new WeakMap();
  var revision = win.__dtfStudioAnalyticsRevision || 0;
  var frames = new Map();
  var loadingPrivacy = false;
  var privacyFailed = false;

  function consentAllowed() {
    if (stopped || !active || privacyFailed || typeof destination !== "function") return false;
    try {
      var privacy = win.Shopify && win.Shopify.customerPrivacy;
      // Require active permission AND Shopify's current processing permission, in every region.
      return (
        !!privacy &&
        privacy.currentVisitorConsent().analytics === "yes" &&
        privacy.analyticsProcessingAllowed() === true
      );
    } catch (_) {
      return false;
    }
  }
  function exactKeys(value, keys) {
    return (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      Object.keys(value).length === keys.length &&
      keys.every(function (key) {
        return Object.prototype.hasOwnProperty.call(value, key);
      })
    );
  }
  function isStudio(frame) {
    try {
      return new URL(frame.src, doc.baseURI).origin === origin;
    } catch (_) {
      return false;
    }
  }
  function permission(frame, force) {
    var allowed = consentAllowed();
    var state = permissions.get(frame);
    if (!state || state.allowed !== allowed || force) {
      state = { allowed: allowed, revision: ++revision, acknowledged: false };
      win.__dtfStudioAnalyticsRevision = revision;
      permissions.set(frame, state);
    }
    return state;
  }
  function syncFrame(frame, force) {
    if (!isStudio(frame) || !frame.contentWindow) return;
    var state = permission(frame, force);
    frame.contentWindow.postMessage(
      {
        type: "dtf-logo-studio:consent",
        version: 1,
        analytics: state.allowed,
        revision: state.revision,
      },
      origin,
    );
  }
  function sync() {
    if (stopped) return;
    doc.querySelectorAll("iframe[data-logo-studio-frame]").forEach(function (frame) {
      if (!frames.has(frame)) {
        var loaded = function () {
          seen.delete(frame);
          syncFrame(frame, true);
        };
        frames.set(frame, loaded);
        frame.addEventListener("load", loaded);
      }
      syncFrame(frame);
    });
    frames.forEach(function (loaded, frame) {
      if (!frame.isConnected) {
        frame.removeEventListener("load", loaded);
        frames.delete(frame);
      }
    });
  }
  function loadPrivacy() {
    if (stopped || loadingPrivacy) return;
    if (win.Shopify && win.Shopify.customerPrivacy) {
      sync();
      return;
    }
    if (!win.Shopify || typeof win.Shopify.loadFeatures !== "function") {
      sync();
      return;
    }
    loadingPrivacy = true;
    try {
      win.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          loadingPrivacy = false;
          privacyFailed = !!error;
          sync();
        },
      );
    } catch (_) {
      loadingPrivacy = false;
      privacyFailed = true;
      sync();
    }
  }
  function receive(event) {
    if (stopped || event.origin !== origin) return;
    var frame = Array.from(doc.querySelectorAll("iframe[data-logo-studio-frame]")).find(
      function (item) {
        return isStudio(item) && event.source === item.contentWindow;
      },
    );
    if (!frame) return;
    var data = event.data;
    if (
      exactKeys(data, ["type", "version", "revision"]) &&
      data.type === "dtf-logo-studio:consent-ack" &&
      data.version === 1 &&
      Number.isSafeInteger(data.revision) &&
      data.revision > 0
    ) {
      var acknowledged = permission(frame);
      if (acknowledged.revision === data.revision) acknowledged.acknowledged = true;
      return;
    }
    if (
      exactKeys(data, ["type", "version"]) &&
      data.type === "dtf-logo-studio:ready" &&
      data.version === 1
    ) {
      syncFrame(frame);
      loadPrivacy();
      return;
    }
    if (
      !exactKeys(data, ["type", "version", "name", "count"]) ||
      data.type !== "dtf-logo-studio:usage" ||
      data.version !== 1 ||
      !names.includes(data.name) ||
      !Number.isSafeInteger(data.count) ||
      data.count <= 0
    )
      return;
    var counts = seen.get(frame) || Object.create(null);
    if (data.count <= (counts[data.name] || 0)) return;
    counts[data.name] = data.count;
    seen.set(frame, counts);
    // Always reread consent on receipt, including after withdrawal or a missing privacy API.
    var state = permission(frame);
    if (!state.allowed || !state.acknowledged) {
      syncFrame(frame);
      return;
    }
    try {
      destination(data.name, 1);
    } catch (_) {
      /* Drop; never retry or queue events. */
    }
  }
  function consentChanged() {
    sync();
  }
  function resume() {
    active = true;
    sync();
    loadPrivacy();
  }
  function suspend() {
    active = false;
    frames.forEach(function (_, frame) {
      syncFrame(frame);
    });
  }
  win.addEventListener("message", receive);
  win.addEventListener("pageshow", resume);
  win.addEventListener("pagehide", suspend);
  doc.addEventListener("visitorConsentCollected", consentChanged);
  doc.addEventListener("shopify:section:load", resume);
  doc.addEventListener("DOMContentLoaded", resume);
  win.__dtfStudioAnalyticsStop = function () {
    stopped = true;
    suspend();
    win.removeEventListener("message", receive);
    win.removeEventListener("pageshow", resume);
    win.removeEventListener("pagehide", suspend);
    doc.removeEventListener("visitorConsentCollected", consentChanged);
    doc.removeEventListener("shopify:section:load", resume);
    doc.removeEventListener("DOMContentLoaded", resume);
    frames.forEach(function (loaded, frame) {
      frame.removeEventListener("load", loaded);
    });
    frames.clear();
  };
  resume();
})();
